import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';
import { CircleIconComponent } from '../circle-icon/circle-icon.component';

import { Image, ImageTag } from '../../model/hero-report-image/image.model';
import {ValidationErrors} from "@angular/forms";

@Component({
  selector: 'app-image-upload-dropzone',
  standalone: true,
  imports: [CommonModule, InputWrapperComponent, CircleIconComponent],
  templateUrl: './image-upload-dropzone.component.html',
  styleUrls: ['./image-upload-dropzone.component.scss'],
})
export class ImageUploadDropzoneComponent {
  @Output() imageSelected = new EventEmitter<Image>();
  @Output() deleteImage = new EventEmitter<Image>();
  @Input() images: Image[] = [];
  @Input() label?: string;
  @Input() required?: boolean;
  @Input() errorMessage?: ValidationErrors | null;
  @Input() touched?: boolean;
  @Input() maxImages?: number;
  @Input() deleteable?: boolean;

  isDragging = false;
  tag: ImageTag;

  get isAtMaxImages(): boolean {
    return this.maxImages !== undefined && this.images.length >= this.maxImages;
  }

  onDragOver(event: DragEvent) {
    if (this.isAtMaxImages) return;
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    if (this.isAtMaxImages) return;
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    if (this.isAtMaxImages) return;
    event.preventDefault();
    this.isDragging = false;
    const file = event.dataTransfer?.files?.[0];
    this.handleFile(file);
  }

  onFileChange(event: Event) {
    if (this.isAtMaxImages) return;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFile(input.files[0]);
    }
  }

  handleFile(file: File | undefined) {
    if (!file || !file.type.startsWith('image/')) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const url = event.target?.result as string;
      const image: Image = {
        tag: this.tag,
        url: url,
      };
    this.imageSelected.emit(image);
    };
  }

  onDeleteClick(img: Image, event: MouseEvent) {
    event.stopPropagation();
    this.deleteImage.emit(img);
  }
}
